module.exports = __webpack_public_path__ + "img/f-miniature.fc312610.jpg";